<div [formGroup]="booksForm" appAutoAudit [auditData]="fieldAuditData" [auditDisabled]="!!snapshotData">
    <div class="form-title-container">
        <h3>Libros</h3>
        <a class="button add-button" *ngIf="!snapshotData" (click)="openBookModal()">Añadir libro</a>
    </div>

    <div *ngIf="!snapshotData" [formGroup]="booksFiltersForm" class="columns is-multiline">
        <div class="column is-4 filter-container">
            <span class="label">Tipo</span>
            <p-dropdown
                [options]="bookTypes"
                optionLabel="label"
                optionValue="value"
                placeholder="Filtrar por tipo"
                formControlName="type"
                [showClear]="true"
                [emptyFilterMessage]="'No se encontraron resultados'" />
        </div>
        <div class="column is-4 filter-container">
            <span class="label">Fecha legalización libro</span>
            <p-calendar
                [iconDisplay]="'input'"
                dateFormat="dd/mm/yy"
                dataType="date"
                [showIcon]="true"
                inputId="icondisplay"
                [showButtonBar]="true"
                formControlName="bookDate" />
        </div>
        <div class="column is-4 filter-container">
            <span class="label">Ejercicio</span>
            <input class="search-input" type="text" pInputText formControlName="fiscalYear" placeholder="Filtrar por ejercicio" />
        </div>
    </div>

    <div class="card">
        <app-clients-table 
            [configTable]="activeBooksTableConfig" 
            [snapshotMode]="!!snapshotData"
            (openItemEvent)="openBookModal($event)" 
            (deleteItemEvent)="openDeleteBookModal($event)">
        </app-clients-table>
    </div>

    <div class="modal" [ngClass]="{'is-active': isBookModalVisible}">
        <div class="modal-background" (click)="closeBookModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ editingBookIndex !== undefined ? 'Editar libro' : 'Nuevo libro' }}</p>
                <button class="delete" aria-label="close" (click)="closeBookModal()"></button>
            </header>
            <form [formGroup]="bookForm" (submit)="saveBook()">
            <section class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column is-6 form-container">
                            <span class="label">Tipo</span>
                            <p-dropdown [options]="bookTypes" optionLabel="label" optionValue="value" placeholder="Seleccionar tipo" formControlName="type" [emptyFilterMessage]="'No se encontraron resultados'"/>
                        </div>
                        <div class="column is-6 form-container">
                            <span class="label">Número orden libro</span>
                            <input class="search-input" type="text" pInputText formControlName="orderNumber"/>
                        </div>
                        <div class="column is-6 form-container">
                            <span class="label">Fecha legalización libro</span>
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="bookDate"/>
                        </div>
                        <div class="column is-6 form-container">
                            <span class="label">Ejercicio</span>
                            <input class="search-input" type="text" pInputText formControlName="fiscalYear"/>
                        </div>
                        <div class="column is-12 form-container">
                            <span class="label">Observaciones</span>
                            <textarea class="search-input observations-field" pInputTextarea [autoResize]="true" formControlName="observations" rows="3" maxlength="2000"></textarea>
                        </div>
                    </div>
                </section>
                @if (submitError) {
                  <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
                }
                <footer class="modal-card-foot buttons-container">
                    <ng-container *ngIf="snapshotData; else bookEditButtons">
                        <button type="button" class="button cancel-button" (click)="closeBookModal()">Cerrar</button>
                    </ng-container>
                    <ng-template #bookEditButtons>
                        <button class="button cancel-button" (click)="closeBookModal()">Cancelar</button>
                        <button class="button save-button" type="submit" [disabled]="!bookForm.valid">Guardar</button>
                    </ng-template>
                </footer>
            </form>
        </div>
    </div>

    <div class="modal" [class.is-active]="isDeleteBookModalVisible">
        <div class="modal-background" (click)="closeDeleteBookModal()"></div>
            <div class="modal-content">
    
                        <h1 class="title">Eliminar libro</h1>
                    <div class="select-container columns">
                        <div class="column is-12">
                            <span>
                                ¿Está seguro/a que desea eliminar el libro?
                            </span>
                        </div>
                        @if (submitError) {
                          <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
                        }
                        <div class="buttons-container">
                            <button class="button is-outlined cancel-button" (click)="closeDeleteBookModal()">Cancelar</button>
                            <button class="comment-button button is-pulled-right" (click)="confirmDeleteBook()" >Aceptar</button>      
                        </div>
                    </div>             
            </div>
        </div>
</div>

